module.exports = __webpack_public_path__ + "img/long.be5030ca.webp";